"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const base_1 = __importDefault(require("./base"));
const defaults_1 = require("./defaults");
class Image extends base_1.default {
    constructor(data = {
        id: undefined,
        url: undefined,
        ext: undefined,
        name: undefined,
        created_at: undefined,
        created_by: undefined,
    }) {
        super(data);
        this.id = (0, defaults_1.defaultString)(data.id);
        this.url = (0, defaults_1.defaultString)(data.url);
        this.ext = (0, defaults_1.defaultString)(data.ext);
        this.name = (0, defaults_1.defaultString)(data.name);
        this.createdAt = (0, defaults_1.defaultString)(data.created_at);
        this.createdBy = (0, defaults_1.defaultNumber)(data.created_by);
    }
}
exports.default = Image;
